// extracted by mini-css-extract-plugin
export default {"Message":"Intent_Message__04w5+"};